import './faq.css';
import Header from '../componentes/header/header';
import Footer from '../componentes/footer/footer';
import { FaQuestionCircle, FaChevronDown } from "react-icons/fa";
import React, { useState } from 'react';

const FAQ = () => {

  const faqData = [
    {
      id: 1,
      pergunta: "Pergunta 1",
      resposta: "Ao perguntar uam pergunta, quantas perguntas forem feitas serão respondidas"
    },
    {
      id: 2,
      pergunta: "Pergunta 2",
      resposta: "dkfsdlfkldsfl dfsdlkf sd fdskl flkadfndsakdnsajdnsDL OO S DSA JDBASKDAKSDKA"
    },
    {
      id: 3,
      pergunta: "Pergunta 3",
      resposta: "lksefdjfkadsfjdsk dlk fnkldsflsd kfalsdklaskdasl jd fkjdsbslsakfbabdsadkd s kddskfbskdf"
    },
    {
      id: 4,
      pergunta: "Pergunta 4",
      resposta: "adlfksfjksd  sdkfsdjfndsldkl fdnfsdjakjfdajkfnaksdnslk  jd fkdsfajkasadkfsakask    sdasdbsabdaskd"
    },
    {
      id: 5,
      pergunta: "Pergunta 5",
      resposta: "sjfsjkfhsdfjdskf skfjkds fksdjfafaqsndlasfnaçsaskdfasd gasçgsaçgaççjfnSÇFSADJKFÇSSDD   FSDF DAFDAFDA"
    },
    {
      id: 6,
      pergunta: "Pergunta 6",
      resposta: "isfhsjfds fo gsgskgndjsnf ksdfnsdkffkdmgnskdjfasdkfdskjfndsafnsdkfkdsf."
    },
  ];

  // Estado para controlar qual pergunta (ID) está aberta. Null se nenhuma estiver aberta.
  const [openId, setOpenId] = useState(null);

  // Função para lidar com o clique na pergunta (abre/fecha o item)
  const handleToggle = (id) => {
    setOpenId(openId === id ? null : id); // Se já estiver aberto, fecha (null); senão, abre.
  };

  return (
    <>
      <Header />

      <div className="detalhe-header-condicoes">
        <div className="detalhe-title-content">
          <FaQuestionCircle size={24} className="detalhe-icon" />
          <h1 className="detalhe-title">FAQ</h1>
        </div>
      </div>

      <div className="termos-container faq-container"> {/* Adicionei faq-container para estilização */}

        {faqData.map((item) => (
          <div key={item.id} className="faq-item">

            {/* Pergunta (Cabeçalho do Accordion) */}
            <div
              className={`faq-question-header ${openId === item.id ? 'open' : ''}`}
              onClick={() => handleToggle(item.id)}
            >
              <h3 className="faq-question-text">{item.pergunta}</h3>
              {/* Ícone que gira ao abrir */}
              <FaChevronDown className="faq-arrow-icon" />
            </div>

            {/* Resposta (Conteúdo do Accordion) */}
            <div className={`faq-answer-content ${openId === item.id ? 'active' : ''}`}>
              <p className="faq-answer-text">{item.resposta}</p>
            </div>

          </div>
        ))}

      </div>


      <Footer />
    </>
  )
}

export default FAQ;